import React, { useState } from 'react'
import {
  createNgReactBridgeDirective,
  createNgReactBridgeFactory,
  createNgReactBridgeConstant,
  createNgReactBridgeController
} from '../../react-bridge'
import { SERVER_ENVIRONMENT_LIST } from './legacy-constants'
import { ServerSettingsCtrl } from './legacy-server-settings-controller'
import {
  SyslogSettingsForm,
  SyslogSettingsFormState
} from '../../../components/syslog'
import { FormValidator } from '../../../legacy-design-system/form'
import { ServerFactory } from './legacy-server-factory'

createNgReactBridgeConstant('SERVER_ENVIRONMENT_LIST', SERVER_ENVIRONMENT_LIST)
createNgReactBridgeController('ServerSettingsCtrl', ServerSettingsCtrl)

function Bridge({
  settings,
  onChange,
  onValidityChange,
  viewOnly
}: {
  settings: SyslogSettingsFormState
  onChange: (value: SyslogSettingsFormState) => void
  onValidityChange?: (formIsValid: boolean) => void
  viewOnly?: boolean
}) {
  const [isValid, setIsValid] = useState<boolean | undefined>(undefined)
  return (
    <FormValidator value={settings}>
      {({ getFormFieldProps, formIsValid }) => {
        if (typeof isValid === 'undefined' || isValid !== formIsValid) {
          setIsValid(formIsValid)
          if (onValidityChange) {
            onValidityChange(formIsValid)
          }
        }
        return (
          <SyslogSettingsForm
            viewOnly={viewOnly}
            state={settings}
            onChange={onChange}
            getFormFieldProps={getFormFieldProps}
          />
        )
      }}
    </FormValidator>
  )
}

createNgReactBridgeDirective('reactSyslogSettingsForm', [], Bridge, [
  'settings',
  'onChange',
  'onValidityChange'
])

createNgReactBridgeFactory('ServerFactory', ServerFactory)
